<div mat-dialog-title class="modal-header header-radius-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Member Info</h4>
        </div>
        <div>
            <button type="button" class="close close-btn" title="close" mat-dialog-close>
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>
<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <div class="form-group col-sm-6">
            <label>Name</label>
            <input type="text" class="form-control" disabled [value]="name ? name : null">
        </div>
        <div class="form-group col-sm-6">
            <label>Designation</label>
            <input type="text" class="form-control" disabled
                [value]="memberInformation.designation ? memberInformation.designation : null">
        </div>
        <div class="form-group col-sm-6">
            <label>Phone</label>
            <input type="text" class="form-control" disabled
                [value]="memberInformation.phoneNumber ? memberInformation.phoneNumber : null">
        </div>
        <div class="form-group col-sm-6">
            <label>Email</label>
            <input type="text" class="form-control" disabled
                [value]="memberInformation.email ? memberInformation.email : null">
        </div>
        <div class="form-group col-sm-6">
            <label>Role</label>
            <input type="text" class="form-control" disabled
                [value]="memberInformation.memberRole ? getMemberRoleList(memberInformation.memberRole) : null">
        </div>
        <div class="form-group col-sm-6">
            <label>Member Type</label>
            <input type="text" class="form-control" disabled
                [value]="memberInformation.memberType ? memberInformation.memberType : null">
        </div>
        <div class="form-group text-align-end col-sm-12 col-xs-12 padding-y-15">
            <button mat-dialog-close title="Cancel" class="flat-butt flat-danger-butt flat-danger-grad-butt">
                Cancel
            </button>
        </div>
    </div>
</mat-dialog-content>